import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import historyPhoto1 from "../../../assets/history-photo-1.webp";
import historyPhoto2 from "../../../assets/history-photo-2.webp";
import historyPhoto3 from "../../../assets/history-photo-3.webp";
import historyPhoto4 from "../../../assets/history-photo-4.webp";
import historyPhoto5 from "../../../assets/history-photo-5.webp";
import historyPhoto6 from "../../../assets/history-photo-6.webp";
import SlideIn from "../../ui/SlideIn/SlideIn.js";
import "./HistoryStyles.scss";

const MILESTONES = [
	{ id: "foundation", image: historyPhoto1 },
	{ id: "dunavParty", image: historyPhoto2 },
	{ id: "bbDacha", image: historyPhoto3 },
	{ id: "vrsBreakthrough", image: historyPhoto4 },
	{ id: "studioLaunch", image: historyPhoto5 },
	{ id: "yungstarSeries", image: historyPhoto6 },
];

function History() {
	const { t } = useTranslation();

	const milestones = useMemo(
		() =>
			MILESTONES.map((item, index) => ({
				...item,
				reverse: index % 2 === 1,
			})),
		[],
	);

	return (
		<section id="history" className="history">
			<div className="history-section">
				<div className="history-heading">
					<SlideIn direction="up" delay={100} threshold={0.1}>
						<h2 className="tracking-in-expand">{t("history.title")}</h2>
					</SlideIn>
				</div>

				<div className="history-timeline">
					<div className="history-timeline__line" aria-hidden="true" />

					<div className="history-blocks">
						{milestones.map(({ id, reverse, image }, index) => (
							<SlideIn
								key={id}
								direction="up"
								delay={50 + index * 50}
								threshold={0.1}
							>
								<article
									className={`history-block${
										reverse ? " history-block--reverse" : ""
									}`}
								>
									<div className="history-block__text">
										<div className="history-block__content">
											<h3>{t(`history.milestones.${id}.title`)}</h3>
											<p
												dangerouslySetInnerHTML={{
													__html: t(`history.milestones.${id}.description`),
												}}
											/>
										</div>
										<span className="history-block__year">
											{t(`history.milestones.${id}.year`)}
										</span>
									</div>
									<div className="history-block__image">
										<img
											src={image}
											alt={t(`history.milestones.${id}.title`)}
											loading="lazy"
										/>
									</div>
								</article>
							</SlideIn>
						))}
					</div>

					<SlideIn direction="up" delay={100} threshold={0.1}>
						<a href="/about" className="history-explore">
							{t("history.exploreMore")}
						</a>
					</SlideIn>
				</div>
			</div>
		</section>
	);
}

export default History;
